










import { Component, Vue, Prop } from 'vue-property-decorator';

export type TypeTagVariant = 'big' | 'medium' | 'small';

@Component({
  components: {}
})
export default class TagSpecialCoin extends Vue {
  @Prop() text!: string;
  @Prop({ default: 'medium' }) variant!: TypeTagVariant;
}
